
<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    HEADER
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<ion-header>
    <ion-toolbar>

        <ion-title mode="ios" role="heading">{{ 'MENU_HEADER' | translate}}</ion-title>

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    CONTENT
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<ion-content>

    <br /><br /><br />
    <div class="list-container">
        <ion-list role="list" class="list-compact">

            <!--
            <ion-item>
                <ion-label [innerHTML]="'MENU_VIEW_TYPE' | translate"></ion-label>
                <ion-select [(ngModel)]="rosterViewType">
                    <ion-option [innerHTML]="'MENU_VIEW_TYPE_TIMELINE' | translate" value="timeline"></ion-option>
                    <ion-option [innerHTML]="'MENU_VIEW_TYPE_LIST' | translate" value="list"></ion-option>
                </ion-select>
            </ion-item>


            <ion-item *ngIf="isDevice">
                <ion-label>Map type</ion-label>
                <ion-select [(ngModel)]="mapType">
                    <ion-option value="JAVASCRIPT">Javascript</ion-option>
                    <ion-option value="NATIVE">Native</ion-option>
                </ion-select>
            </ion-item>
            </ion-item>
            -->

            <!-- <button ion-item (click)="presentModal('FeedbackPage')">
                <ion-icon name="ios-chatbubbles" item-start></ion-icon>
                {{ 'MENU_FEEDBACK_LABEL' | translate }}
                <ion-icon name="ios-arrow-forward" item-end></ion-icon>
            </button> -->

            <!--FeedbackZendeskPage-->
            <ion-item button role="listitem" (click)="presentModal('feedback')">
                <ion-icon name="chatbox-outline" aria-hidden="true" slot="start"></ion-icon>
                <p>{{ 'MENU_FEEDBACK_LABEL' | translate }}</p>
                <ion-icon name="chevron-forward-outline" aria-hidden="true" slot="end"></ion-icon>
            </ion-item>


            <ion-item button role="listitem" (click)="presentModal('howTo')">
                <ion-icon name="help-circle-outline" aria-hidden="true" slot="start"></ion-icon>
                <p>{{ 'MENU_HOW_TO_LABEL' | translate }}</p>
                <ion-icon name="chevron-forward-outline" aria-hidden="true" slot="end"></ion-icon>
            </ion-item>

            <ion-item button role="listitem" (click)="presentModal('terms')">
                <ion-icon name="newspaper-outline" aria-hidden="true" slot="start"></ion-icon>
                <p>{{ 'MENU_TERMS_LABEL' | translate }}</p>
                <ion-icon name="chevron-forward-outline" aria-hidden="true" slot="end"></ion-icon>
            </ion-item>

            <!-- <button ion-item (click)="presentModal('PrivacyPage')">     {{ 'MENU_PRIVACY_LABEL'     | translate }}</button> -->
            <!-- <button ion-item (click)="onClickLog()">                   {{ 'MENU_LOG_LABEL'       | translate }}</button> -->
        </ion-list>
    </div>

    <div class="metadata" *ngIf="translationData" (click)="onClickMetadata()">
        <h6 role="none" [innerHTML]="'MENU_VERSION'   | translate: translationData"></h6>
        <h6 role="none" [innerHTML]="'MENU_USER_NAME' | translate: translationData"></h6>
        <!-- <h6 [innerHTML]="'MENU_PASSWORD'  | translate: translationData"></h6> -->
    </div>

</ion-content>
